<template>
    <tq-loader-container class="TQ_center" :p_show-loader_b="!co_ticketError_s
                         && (showLoader_b || server_currentUserData_c === undefined || server_questEvent_c === undefined || server_questExplore_c === undefined)">

        <div class="TQ_center3_fullScreen_container">
            <div class="TQ_center3_body_inner">

                <!-- 1) errors -->
                <div v-if="co_ticketError_s != null" class="TQ_bg_white TQ_borderRadius TQ_inline TQ_text_capitalize">

                    <div class="TQ_text_28px TQ_center TQ_bg_purple_dark TQ_padding_8px TQ_borderRadius_top">
                        {{ass_strings.oneWord_error[store_system_langCode_ve.val]}}
                    </div>

                    <div class="TQ_text_20px TQ_padding_16px TQ_center TQ_width_200px">
                        {{co_ticketError_s}}
                    </div>

                    <div class="TQ_padding_16px TQ_border_top" >
                        <div class="TQ_padding_8px TQ_bg_red TQ_box_shadow2 TQ_borderRadius TQ_text_20px TQ_clickable TQ_inline TQ_width_100px"
                             @click="m_moveBackToTicketsList_f">
                            {{ass_strings.oneWord_exit[store_system_langCode_ve.val]}}
                        </div>
                    </div>
                </div>

                <!-- 2) ticket info-->
                <div v-else-if="!clickContiuneBtn_b" class="TQ_box_shadow2 TQ_inline TQ_bg_white TQ_maxWidth_400px TQ_width_100vw TQ_borderRadius_top">

                    <c_-player_-tickets_-item_-ticket
                        v-if="server_questEvent_c "
                        class="TQ_center TQ_border_bottom "
                        :p_quest-event_c="server_questEvent_c"
                        :p_quest-event-ticket_c="server_questTicket_c"
                        :p_ticket-owner_b="false"
                        :p_system-lang-code_e="store_system_langCode_ve.val"/>

                    <!-- approve terms and continue btn -->
                    <div class="TQ_margin_16px">

                        <div class="TQ_align_initial TQ_margin_bottom_16px">

                            <tq-checkbox class="TQ_width_32px TQ_inline" :p_checked_b="approveCreatorTerms_b" @click.native="approveCreatorTerms_b = !approveCreatorTerms_b"/>
                            <div class="TQ_padding_4px TQ_inline"></div>

                            <div class="TQ_inline" >
                                <div class="TQ_inline TQ_text_capitalize">
                                    {{ass_strings.threeWords_iAgreeTo[store_system_langCode_ve.val]}}
                                </div>
                                <div class="TQ_padding_2px TQ_inline"></div>
                                <div class="TQ_inline TQ_link" @click="showCreatorTerms_vb.val = true"> {{ass_strings.twoWords_creatorTerms[store_system_langCode_ve.val]}} </div>
                            </div>
                        </div>

                        <div @click="m_clickContinueBtn_f" class="TQ_bg_purple TQ_box_shadow TQ_padding_8px TQ_borderRadius TQ_text_24px TQ_grid_col_1frAuto TQ_clickable">
                            <div class="TQ_grid_verticalCenter">
                                {{ass_strings.oneWord_Continue[store_system_langCode_ve.val]}}
                            </div>
                            <div class="TQ_animation_beacon TQ_bg_circle TQ_width_12px TQ_height_12px TQ_grid_verticalCenter"></div>
                        </div>
                    </div>

                </div>

                <!-- 3) login -->
                <div v-else-if="server_currentUserData_c === null" >
                    <tq-login  :p_system_lang-code_e="store_system_langCode_ve.val"
                               :p_fb-auth_c="store_fbAuth_vc.val"
                               :p_hideLoginOption_ae="hideLoginOptions_ae"
                               class="TQ_bg_white TQ_borderRadius TQ_box_shadow  TQ_inline TQ_maxWidth_350px TQ_width_100vw TQ_borderBox"/>
                </div>

                <!-- 4) popup creator terms  -->
                <tq-popup :show="showCreatorTerms_vb" v-if="server_questExplore_c" max-width="450px" :show-close-btn="true" padding="0px">

                    <!-- creators terms -->
                    <div class="TQ_text_24px TQ_center TQ_bg_purple_dark TQ_text_bold TQ_padding_16px TQ_borderRadius_top">
                        {{ass_strings.twoWords_creatorTerms[store_system_langCode_ve.val]}}
                    </div>

                    <!-- creator terms -->
                    <div class="TQ_padding_16px TQ_bg_white"
                         v-html="server_questExplore_c.qex_creatorTerms_byLangCode_c[co_qex_displayLangCode_e].w_body_s"> </div>

                    <!-- approve btn -->
                    <div class="TQ_border_top TQ_padding_8px">
                        <div class="TQ_center TQ_clickable TQ_padding_8px TQ_bg_green  TQ_box_shadow2 TQ_borderRadius TQ_text_20px" @click="m_userEvent_approveCreatorTerms">
                            {{ass_strings.oneWord_approve[store_system_langCode_ve.val]}}
                        </div>
                    </div>

                </tq-popup>

            </div>
        </div>
    </tq-loader-container>
</template>

<script>
    import {store_getStateValue_vo, store_setStateValue, store_var} from "@/store";
    import {route_getUrlParams, route_moveToRoute, route_replace} from "@/router";
    import TqLogin from "../../../components/complex/TqLogin";
    import {
        serverAuth_currentUserData_get_vl_fp,
        serverAuth_currentUserData_remove_vl_f
    } from "@/scripts/Server/S_ServerAuth";
    import {ass_strings} from "../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {enum_urlParams, enum_moveToOptions, enum_questTicketStatus, enum_loginMethods} from "../../../../functions/src/shareCode/Share_S_Enum";
    import {obj_size_fn} from "../../../../functions/src/shareCode/Share_S_Obj";
    import {serverBig_questExplore_once_f} from "@/scripts/Server/S_ServerFirestore";
    import {
        server_addTicketPointerToUser_f, server_questEvent_once_f, server_getQuestTicket_once_f,
        server_playerUseTicket_f
    } from "@/scripts/Server/S_ServerPre";
    import {helper_getDisplayLang_e} from "@/scripts/S_Helper";

    import TqBeacon from "../../../components/basic2/TqBeacon";
    import TqLoaderContainer from "@/components/basic/TqLoaderContainer";
    import TqImgFillBlur from "@/components/basic2/TqImgFillBlur";
    import C_Player_Tickets_Item_Ticket
        from "@/views/v_player/v_Player_Play/v_Player_Play_Item/c_Player_Play_Item_Ticket";
    import TqToggleSwitch from "@/components/basic/TqToggleSwitch";
    import TqCheckbox from "@/components/basic/TqCheckbox";
    import TqPopup from "@/components/basic/TqPopup";
    import {notification_notify} from "@/scripts/S_Notification";

    export default {
        name: "v_player_tickets_item",
        components: {
            TqPopup,
            TqCheckbox,
            TqToggleSwitch, C_Player_Tickets_Item_Ticket, TqImgFillBlur, TqLoaderContainer, TqBeacon, TqLogin},
        data(){
            return {

                showError_notExistingTicket_b   : false,
                showError_usedTicket_b          : false,
                showLoader_b                    : false,
                clickContiuneBtn_b              : false,
                approveCreatorTerms_b           : false,
                showCreatorTerms_vb             : {val : false},
                hideLoginOptions_ae             : [],

                // store
                store_system_langCode_ve        : store_getStateValue_vo(store_var.system_langCode),
                store_fbAuth_vc                 : store_getStateValue_vo(store_var.fb_auth),

                // server
                server_currentUserData_c        : undefined,
                server_questExplore_c           : undefined,
                server_questTicket_c            : undefined,
                server_questEvent_c             : undefined,

                // import
                ass_strings: ass_strings,

            }
        },
        computed:{
            co_qex_displayLangCode_e(){
                return helper_getDisplayLang_e(this.store_system_langCode_ve.val,
                    this.server_questExplore_c.qex_langArr_ae,
                    this.server_questExplore_c.qex_mainLang_e)
            },
            co_ticketError_s(){

                if(this.showError_notExistingTicket_b){
                    return ass_strings.fourWords_entryCodeNotExist[this.store_system_langCode_ve.val]
                }

                if(this.showError_usedTicket_b){
                    return ass_strings.twoWords_usedTicket[this.store_system_langCode_ve.val]
                }

                if(this.server_questTicket_c == null){
                    return null
                }

                switch(this.server_questTicket_c.qt_status_e){

                    case enum_questTicketStatus.waitingToApprove:
                    case enum_questTicketStatus.creatorRequest:
                        return ass_strings.fourWords_notApprovedByCreator[this.store_system_langCode_ve.val]
                    case enum_questTicketStatus.expired:
                        return ass_strings.twoWords_TicketExpired[this.store_system_langCode_ve.val]
                    case enum_questTicketStatus.canceled:
                        return ass_strings.twoWords_TicketCancel[this.store_system_langCode_ve.val]
                }



                return null
            }
        },
        methods:{

            m_clickContinueBtn_f(){

                if(!this.approveCreatorTerms_b){
                    notification_notify(ass_strings.oneWord_notice, ass_strings.sentence_pleaseApproveTheCreatorTerms)
                    return
                }


                // user not login => show login
                if(!this.server_currentUserData_c){
                    this.clickContiuneBtn_b=true
                // user used ticket => move to quest
                }else if(this.server_currentUserData_c && this.server_questTicket_c.qt_playersJoinDate_byUserId_t[this.server_currentUserData_c.ud_userId_uid]){
                    this.m_moveToOngoingQuest_f()
                // error ticket is full
                }else if(obj_size_fn(this.server_questTicket_c.qt_playersJoinDate_byUserId_t) >= this.server_questTicket_c.qt_spots_n){
                    this.showError_usedTicket_b = true
                // new player & user login => update DB & move to quest
                }else{
                    this.m_newPlayerJoin_f()
                }

            },
            m_newPlayerJoin_f(){
                this.showLoader_b = true;

                // update user - add Ticket to user
                server_addTicketPointerToUser_f(this.server_currentUserData_c.ud_userId_uid, this.server_questTicket_c, () => {})

                // update Ticket
                server_playerUseTicket_f(this.server_questTicket_c, this.server_currentUserData_c.ud_userId_uid, () => {
                    this.showLoader_b = false
                    this.m_moveToOngoingQuest_f()
                })
            },

            m_userEvent_approveCreatorTerms(){
                this.showCreatorTerms_vb.val = false
                this.approveCreatorTerms_b = true
            },
            m_moveToOngoingQuest_f(){
                this.showLoader_b=true
                store_setStateValue(store_var.ongoing_questEvent, this.server_questEvent_c)
                route_replace(enum_moveToOptions.ongoing_status)
            },
            m_moveBackToTicketsList_f(){
                route_moveToRoute(enum_moveToOptions.player_play_list);
            },


        },

        activated(){

            this.showLoader_b=false
            this.clickContiuneBtn_b=false

            let urlTicketId_uid = route_getUrlParams(this.$route,enum_urlParams.ticketId)
            let loginHideGoogle = route_getUrlParams(this.$route,enum_urlParams.loginHideGoogle)!== undefined

            if(loginHideGoogle)
                this.hideLoginOptions_ae.push(enum_loginMethods.google)

            // 1) get getQuestTicket
            server_getQuestTicket_once_f(urlTicketId_uid, true, questTicket_c => {
                this.server_questTicket_c = questTicket_c

                // ticket not exist
                if (questTicket_c == null) {
                    this.showError_notExistingTicket_b = true
                    return
                }

                // 2) get questEvent
                server_questEvent_once_f(questTicket_c.qt_questType_e, questTicket_c.qt_questId_uid, questTicket_c.qt_eventId_uid, true, (questEvent_c) => {
                    this.server_questEvent_c = questEvent_c
                })

                // 3) get currentUser
                serverAuth_currentUserData_get_vl_fp(this.$options.name, (currentUserData_c) => {

                    this.server_currentUserData_c = currentUserData_c

                    // 3.1) user not login
                    if(!this.server_currentUserData_c){
                        return
                    }

                    // 3.2) user login
                    if(this.clickContiuneBtn_b){
                        this.m_clickContinueBtn_f()
                    }

                })

                // 4) get quest explore
                serverBig_questExplore_once_f(questTicket_c.qt_questId_uid, true, (questExplore_c) => {

                    this.server_questExplore_c = questExplore_c
                })
            })


        },
        deactivated(){
            serverAuth_currentUserData_remove_vl_f(this.$options.name)
        },
    }

</script>

<style scoped>

</style>